import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { ScrollText } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password.length < 7) { setErr("A palavra-passe deve ter pelo menos 7 caracteres."); return; }
    if (password !== confirm) { setErr("As palavras-passe não coincidem."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/entrar"), 2200);
    } catch (e) { setErr(apiErr(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-ec-bg p-6">
      <div className="w-full max-w-md bg-white rounded-[16px] shadow-[0_8px_30px_rgb(0,0,0,0.06)] p-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-ec-green">
            <ScrollText size={20} strokeWidth={1.5} className="text-ec-gold" />
          </span>
          <span className="font-heading text-2xl text-ec-green">ImoDesk</span>
        </div>
        <h2 className="font-heading text-xl text-ec-green mb-1">Definir nova palavra-passe</h2>
        <p className="text-sm text-slate-500 mb-6">Escolha uma palavra-passe com pelo menos 7 caracteres.</p>
        {err && <div className="mb-4 text-sm bg-red-50 text-red-700 border border-red-200 rounded-lg px-3 py-2" data-testid="reset-error">{err}</div>}
        {done ? (
          <div className="text-sm bg-green-50 text-green-800 border border-green-200 rounded-lg px-4 py-3" data-testid="reset-done">
            Palavra-passe alterada. A redirecionar para a entrada…
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Nova palavra-passe</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={7} className="mt-1.5" data-testid="reset-password" />
            </div>
            <div>
              <Label>Confirmar</Label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1.5" data-testid="reset-confirm" />
            </div>
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full bg-ec-green text-white py-2.5 rounded-lg font-semibold hover:bg-ec-greenDark transition-colors disabled:opacity-60">
              {loading ? "A guardar…" : "Guardar palavra-passe"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
